import { AssessmentDetails } from "Assessments";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";
export default store => ({
  path: ":classplanner_id/weekly",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "teacher-weeklyplanner" */ "./components"),
        import(
          /* webpackChunkName: "teacher-weeklyplanner" */ "LearningCourseWeeklyPlanning/modules/WeeklyPlanningModule"
        ),
        import(
          /* webpackChunkName: "unit-planner" */ "AppComponents/EntityFlowComponents/ImportFromUnitFlowModal/modules/Module"
        ),
        import(
          /* webpackChunkName: "teacher-weeklyplanner" */ "./components/WeeklyPlanningView/components/EventComponent/components/CourseFlowModal/modules/CourseFlowModalModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          injectReducer(store, {
            key: "weeklyPlanning",
            reducer,
          });
          const importFromUnitFlowModalReducer = importedModule2.default;
          injectReducer(store, {
            key: "importFromUnitFlow",
            reducer: importFromUnitFlowModalReducer,
          });
          const courseFlowModalReducer = importedModule3.default;
          injectReducer(store, {
            key: "courseFlowModal",
            reducer: courseFlowModalReducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [AssessmentDetails(store), ClassRoomDetails(store)],
});
